import { render, staticRenderFns } from "./MessageModal.vue?vue&type=template&id=810423dc&scoped=true&"
import script from "./MessageModal.vue?vue&type=script&lang=ts&"
export * from "./MessageModal.vue?vue&type=script&lang=ts&"
import style0 from "./MessageModal.vue?vue&type=style&index=0&id=810423dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "810423dc",
  null
  
)

export default component.exports